export const UPDATE_TOOL_COMPONENT = 'UPDATE_TOOL_COMPONENT';


// WEBPACK FOOTER //
// ./src/store/modules/header/mutations.js